// extracted by mini-css-extract-plugin
export default {"video":"styles_video__UF034","content":"styles_content__9yw8K","title":"styles_title__gi6Xv"};